import React, { useEffect, useState } from "react";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import rehypeExternalLinks from "rehype-external-links";

type ResultItem = {
    query: string;
    results: { content: string; url?: string }[];
};

type QueryData = {
    section: string;
    subsection: string;
    results: ResultItem[];
};

interface Props {
    data: any;
    interval?: number;
}



const QuerySlideshow: React.FC<Props> = ({ data, interval = 5000 }) => {
    const [slides, setSlides] = useState<
        { section: string; subsection: string; query: string; content: string }[]
    >([]);
    const [currentIndex, setCurrentIndex] = useState(0);

    // Prepare the flattened list of slides from results[]
    useEffect(() => {
        const flat = data?.flatMap((entry: any) =>
            entry.results.map((r: any) => ({
                section: entry.section,
                subsection: entry.subsection,
                query: r.query.trim(),
                content: r.results?.[0]?.content?.slice(0, 2000) || "No content available.",
            }))
        );
        setSlides(flat);
    }, [data]);

    // Slide transition timer
    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentIndex((prev) =>
                slides.length ? (prev + 1) % slides.length : 0
            );
        }, interval);
        return () => clearInterval(timer);
    }, [slides, interval]);

    if (slides.length === 0) return null;

    const current = slides[currentIndex];

    return (
        <div className="flex justify-center items-center pt-2">
            <div className=" max-w-3xl w-full space-y-2 transition-all duration-500">

                <div className="text-lg font-bold text-secondary-800 uppercase tracking-wide">
                    {current.section}
                </div>
                <div className="text-md font-medium text-secondary-800">
                    {current.subsection}
                </div>
                <div className="text-base font-semibold text-secondary-800">
                    {current.query}
                </div>
                <div className="text-secondary-800 text-sm whitespace-pre-line mt-2 max-h-[300px] overflow-y-auto border-t pt-4">
                    <Markdown
                        className="markdownWrapper markdownWrapperRep text-secondary-800 text-align relative before:content-[''] before:absolute before:left-0 before:top-0 before:w-[2px] before:h-full before:bg-gray-300 before:mr-2 pl-2"
                        remarkPlugins={[remarkGfm]}
                        rehypePlugins={[
                            [rehypeExternalLinks, { target: "_blank", rel: "noopener noreferrer" }],
                        ]}
                    >{current.content}
                    </Markdown>
                </div>
            </div>
        </div>
    );
};

export default QuerySlideshow;
